import { PAYMENT_USING_GIFTCARD, PAYMENT_USING_GIFTCARD_SUCCESS, PAYMENT_USING_GIFTCARD_FAILURE, RESET_GIFT_CARD_TRANSACTION, GIFTCARD_PURCHASE_STATUS, GIFTCARD_PURCHASE_STATUS_SUCCESS, GIFTCARD_PURCHASE_STATUS_FAIL, RESET_PURCHASE_STATUS, } from '../../constants';
const initialState = {
    giftCardSuccessData: [],
    giftCardTransactionStatus: false,
    giftCardTransactionLoading: false,
    giftCardPurchaseStatus: false,
    giftCardStatusloading: false,
    giftCardPurchaseStatResp: {},
    giftCardTransactionFail: false,
};
const paymentsGiftCardReducer = (state = initialState, action) => {
    switch (action.type) {
        case PAYMENT_USING_GIFTCARD:
            return {
                ...state,
                giftCardTransactionStatus: false,
                giftCardTransactionLoading: true,
                giftCardTransactionFail: false,
            };
        case PAYMENT_USING_GIFTCARD_SUCCESS:
            return {
                ...state,
                giftCardTransactionStatus: true,
                giftCardTransactionLoading: false,
                giftCardTransactionFail: false,
            };
        case PAYMENT_USING_GIFTCARD_FAILURE:
            return {
                ...state,
                giftCardTransactionStatus: false,
                giftCardTransactionLoading: false,
                giftCardTransactionFail: true,
            };
        case RESET_GIFT_CARD_TRANSACTION:
            return {
                ...state,
                giftCardTransactionStatus: false,
                giftCardTransactionLoading: false,
                giftCardTransactionFail: false,
            };
        case GIFTCARD_PURCHASE_STATUS:
            return {
                ...state,
                giftCardPurchaseStatus: false,
                giftCardStatusloading: true,
            };
        case GIFTCARD_PURCHASE_STATUS_SUCCESS:
            return {
                ...state,
                giftCardPurchaseStatus: true,
                giftCardStatusloading: false,
                giftCardPurchaseStatResp: action.response,
            };
        case GIFTCARD_PURCHASE_STATUS_FAIL:
            return {
                ...state,
                giftCardPurchaseStatus: false,
                giftCardStatusloading: false,
            };
        case RESET_PURCHASE_STATUS:
            return {
                ...state,
                giftCardPurchaseStatus: false,
                giftCardStatusloading: false,
                giftCardPurchaseStatResp: {},
            };
        default:
            return state;
    }
};
export default paymentsGiftCardReducer;
